module.exports = __webpack_public_path__ + "ccf9402dcb865cc4c35559d36879ea6b.svg";